import React, { useMemo } from 'react';
import { Dropdown } from 'primereact/dropdown';
import GenericTableFilter from '../../../../../components/common/GenericTableFilter';
import DealerDropdown from '../../../../../components/common/DealerDropdownWithMulti';
import WarrantyTypeDropdown from '../../../../../components/common/WarrantyTypeDropdownWithMulti';
import { useLanguage } from '../../../../../contexts/LanguageContext';

const InvoiceApprovalFilter = ({ handleApplyFilters, handleResetFilters }) => {
    const { th } = useLanguage();

    const domesticTypeOptions = useMemo(() => [
        { label: th('invoiceApproval.filters.allDomesticTypes'), value: null },
        { label: th('invoiceApproval.filters.domestic'), value: 1 },
        { label: th('invoiceApproval.filters.international'), value: 2 }
    ], [th]);

    const defaultDates = useMemo(() => {
        const now = new Date();
        return {
            startDate: new Date(now.getFullYear(), now.getMonth(), 1),
            endDate: new Date(now.getFullYear(), now.getMonth() + 1, 0),
            domesticType: null
        };
    }, []);

    const filterFields = useMemo(() => [
        {
            field: 'startDate',
            headerName: th('invoiceApproval.filters.startDate'),
            type: 'date'
        },
        {
            field: 'endDate',
            headerName: th('invoiceApproval.filters.endDate'),
            type: 'date'
        },
        {
            field: 'dealer',
            headerName: `${th('invoiceApproval.filters.dealer')} *`,
            type: 'custom',
            customComponent: ({ value, onChange }) => (
                <DealerDropdown
                    multiple
                    showSelectAll
                    value={value}
                    onChange={onChange}
                    className="w-full"
                    selectedItemsLabel={th('invoiceApproval.filters.selectedItems')}
                />
            )
        },
        {
            field: 'warrantyType',
            headerName: `${th('invoiceApproval.filters.warrantyType')} *`,
            type: 'custom',
            customComponent: ({ value, onChange }) => (
                <WarrantyTypeDropdown
                    multiple
                    showSelectAll
                    emitFilterPayload
                    value={value}
                    onChange={onChange}
                    className="w-full"
                    selectedItemsLabel={th('invoiceApproval.filters.selectedItems')}
                />
            )
        },
        {
            field: 'domesticType',
            headerName: th('invoiceApproval.filters.domesticType'),
            type: 'custom',
            customComponent: ({ value, onChange }) => (
                <Dropdown
                    value={value}
                    options={domesticTypeOptions}
                    onChange={(e) => onChange(e.value)}
                    placeholder={th('invoiceApproval.filters.allDomesticTypes')}
                    className="w-full"
                />
            )
        }
    ], [th, domesticTypeOptions]);

    const customFilterTypes = useMemo(() => ({
        startDate: 'date',
        endDate: 'date',
        dealer: 'custom',
        warrantyType: 'custom',
        domesticType: 'custom'
    }), []);

    return (
        <div className="mb-2">
            <GenericTableFilter
                filterFields={filterFields}
                customFilterTypes={customFilterTypes}
                onApplyFilters={handleApplyFilters}
                onResetFilters={handleResetFilters}
                initialFilters={defaultDates}
                initiallyOpen={true}
            />
        </div>
    );
};

export default InvoiceApprovalFilter;
